/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { validateAuthTokenPermission } from '@/auth/api';

const state = {
  authToken: null,
  redirectUrl: null,
  checkingTokenState: {
    status: 'idle',
    error: null,
  },
};

const mutations = {
  setAuthTokenInformation(state, payload) {
    const { authToken, redirectUrl } = payload;
    state.authToken = authToken;
    state.redirectUrl = redirectUrl;
  },
  setCheckingTokenState(state, message) {
    switch (message.type) {
      case 'loading':
        state.checkingTokenState.status = 'loading';
        state.checkingTokenState.error = null;
        break;
      case 'success':
        state.checkingTokenState.status = 'success';
        break;
      case 'error':
        state.checkingTokenState.status = 'error';
        state.checkingTokenState.error = message.payload;
        break;
      default:
        state.checkingTokenState.status = 'idle';
        state.checkingTokenState.error = null;
    }
  },
};

const getters = {
  checkingTokenState: (state) => state.checkingTokenState,
};

const actions = {
  setAuthTokenInformation({ commit }, payload) {
    commit('setAuthTokenInformation', payload);
  },
  setCheckingTokenState({ commit }, message) {
    commit('setCheckingTokenState', message);
  },
  async checkAuthTokenPermission({ state, commit }, teamName) {
    const payload = {
      authToken: state.authToken,
      teamName,
    };
    try {
      commit('setCheckingTokenState', { type: 'loading' });
      await validateAuthTokenPermission(payload);
      commit('setCheckingTokenState', { type: 'success' });
    } catch (error) {
      commit('setCheckingTokenState', {
        type: 'error',
        payload: error.response.data,
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
